(function () {
	// Predictive search. Two surfaces share one renderer:
	// 1. Desktop (>=992px): the header search icons (a[href="/search"]) open a
	//    full-width overlay panel with a live-results dropdown.
	// 2. Mobile + search page: any .search-bar form input gets an attached
	//    live-results list beneath it.
	// Backed by Shopify's Predictive Search API (/search/suggest.json), which
	// supports prefix matching and SKU fields the plain /search page lacks.
	// Without JS, every entry point still works as a plain link/form.

	var ENDPOINT = '/search/suggest.json';
	var MIN_CHARS = 2;
	var DEBOUNCE_MS = 250;

	function moneyFromString(str) {
		var cents = Math.round(parseFloat(str) * 100);
		if (isNaN(cents)) return '';
		if (window.slate && slate.Currency && window.theme && theme.moneyFormat) {
			try { return slate.Currency.formatMoney(cents, theme.moneyFormat); } catch (e) { /* fall through */ }
		}
		return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
	}

	function thumb(url) {
		if (!url) return '';
		return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
	}

	function esc(s) {
		var d = document.createElement('div');
		d.textContent = s;
		return d.innerHTML;
	}

	function render(container, data, q) {
		var results = (data && data.resources && data.resources.results) || {};
		var queries = results.queries || [];
		var products = results.products || [];
		if (!queries.length && !products.length) {
			container.innerHTML = '<p class="ps-empty">No matches for “' + esc(q) + '”</p>' +
				'<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Search all products →</a>';
			return;
		}
		var html = '';
		if (queries.length) {
			html += '<ul class="ps-queries">' + queries.slice(0, 4).map(function (s) {
				return '<li><a href="/search?q=' + encodeURIComponent(s.text) + '&type=product">' + esc(s.text) + '</a></li>';
			}).join('') + '</ul>';
		}
		if (products.length) {
			html += '<ul class="ps-products">' + products.slice(0, 6).map(function (p) {
				return '<li><a href="' + p.url + '">' +
					(p.image ? '<img src="' + thumb(p.image) + '" alt="">' : '<span class="ps-noimg"></span>') +
					'<span class="ps-title">' + esc(p.title) + '</span>' +
					'<span class="ps-price">' + moneyFromString(p.price) + '</span>' +
					'</a></li>';
			}).join('') + '</ul>';
		}
		html += '<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">All results for “' + esc(q) + '” →</a>';
		container.innerHTML = html;
	}

	function attachLive(input, container) {
		var timer = null;
		var controller = null;
		input.addEventListener('input', function () {
			var q = input.value.trim();
			if (timer) clearTimeout(timer);
			if (q.length < MIN_CHARS) {
				container.hidden = true;
				container.innerHTML = '';
				return;
			}
			timer = setTimeout(function () {
				if (controller) controller.abort();
				controller = ('AbortController' in window) ? new AbortController() : null;
				var url = ENDPOINT + '?q=' + encodeURIComponent(q) +
					'&resources[type]=product,query' +
					'&resources[limit]=6&resources[limit_scope]=each' +
					'&resources[options][unavailable_products]=last' +
					'&resources[options][prefix]=last' +
					'&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
				fetch(url, controller ? { signal: controller.signal } : undefined)
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (input.value.trim() !== q) return; // stale
						render(container, data, q);
						container.hidden = false;
					})
					.catch(function () { /* aborted or offline — keep quiet */ });
			}, DEBOUNCE_MS);
		});
	}

	function init() {
		// --- Desktop overlay
		var overlay = document.querySelector('[data-predictive-search]');
		if (overlay) {
			var psInput = overlay.querySelector('[data-ps-input]');
			var psResults = overlay.querySelector('[data-ps-results]');
			var mqDesktop = window.matchMedia('(min-width: 992px)');

			function openOverlay() {
				overlay.hidden = false;
				document.documentElement.classList.add('ps-open');
				psInput.focus();
			}
			function closeOverlay() {
				overlay.hidden = true;
				document.documentElement.classList.remove('ps-open');
			}

			document.querySelectorAll('header a[href="/search"], .slim-header a[href="/search"]').forEach(function (a) {
				a.addEventListener('click', function (e) {
					if (!mqDesktop.matches) return; // mobile keeps the plain link
					e.preventDefault();
					openOverlay();
				});
			});
			overlay.addEventListener('click', function (e) {
				if (e.target === overlay) closeOverlay();
			});
			var closeBtn = overlay.querySelector('[data-ps-close]');
			if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape' && !overlay.hidden) closeOverlay();
			});
			attachLive(psInput, psResults);
		}

		// --- Inline lists under existing .search-bar inputs (mobile menu + search page)
		document.querySelectorAll('.search-bar form').forEach(function (form) {
			var input = form.querySelector('input[name="q"]');
			if (!input) return;
			var list = document.createElement('div');
			list.className = 'ps-inline-results';
			list.hidden = true;
			form.appendChild(list);
			attachLive(input, list);
			document.addEventListener('click', function (e) {
				if (!form.contains(e.target)) {
					list.hidden = true;
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
